import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { RegexService } from 'src/app/services/regex.service';
import { TokenService } from 'src/app/services/token.service';
import * as Countries from 'src/assets/json/countries.json';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatPrefix, MatFormField, MatLabel, MatSuffix, MatHint } from '@angular/material/form-field';
import { MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    RouterLink,
    MatIcon,
    MatPrefix,
    FormsModule,
    ReactiveFormsModule,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    MatHint,
    MatCheckbox,
    MatSelect,
    MatOption,
  ],
})
export class ProviderDetailComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);
  private api = inject(ApiService);
  protected fb = inject(UntypedFormBuilder);
  protected router = inject(Router);
  dialog = inject(MatDialog);
  private tokenService = inject(TokenService);
  private regex = inject(RegexService);
  permissions = inject(PermissionsService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  provider_id: string = null as any;
  countries: any[] = (Countries as any).default;

  providerForm: UntypedFormGroup;

  constructor() {
    const regex_patterns = this.regex.getRegex();

    this.providerForm = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern(regex_patterns['phone'])])],
      website: [''],
      is_hosting_provider: [false],
      is_domain_provider: [false],
      is_business_mail_provider: [false],
      slug: ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      fact_name: ['', Validators.compose([Validators.required])],
      fact_address: ['', Validators.compose([Validators.required])],
      fact_city: ['', Validators.compose([Validators.required])],
      fact_zipcode: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
      fact_county: ['', Validators.compose([Validators.required])],
      fact_country: ['', Validators.compose([Validators.required])],
      fact_country_alpha2: ['', Validators.compose([Validators.required])],
      vat: ['', Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.provider_id = this.activatedRoute.snapshot.paramMap.get('id') as string;
    this.fetchProvider();
    this.listenCountryChanges();
  }

  save() {
    this.api.updateProvider(this.provider_id, this.providerForm.value).subscribe(data => {});
  }

  delete() {
    if (confirm('¿Estás seguro que quieres eliminar este proveedor?')) {
      this.api.deleteProvider(+this.provider_id).subscribe(data => {
        this.router.navigate(['/employees', 'direction', 'providers']);
      });
    }
  }

  private fetchProvider() {
    this.api.getProvider(this.provider_id).subscribe(data => {
      this.providerForm.patchValue(data);
    });
  }

  private listenCountryChanges() {
    this.providerForm.controls['fact_country'].valueChanges.subscribe(data => {
      for (const c of this.countries) {
        if (c.name == data) {
          this.providerForm.patchValue({ fact_country_alpha2: c.alpha_2 });
          break;
        }
      }
    });
  }
}
